import { Avatar, Box, Card, CardBody, Divider, Flex, Heading, Stack, Text } from '@chakra-ui/react'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
// import UserStatusTable from '../../component/UserStatusTable'
import axios from 'axios'
import { Auth } from '../../component/Auth'
import { useState } from 'react'
function UserDetails() {
    const [userData, setUserData] = useState({})
    const { id } = useParams()

    useEffect(() => {
        let data = JSON.stringify({
            "userId": `${id}`
          });
          
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/single-user-account`,
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': Auth()
            },
            data : data
          };
          
          axios.request(config)
          .then((response) => {
            setUserData(response.data);
          })
          .catch((error) => {
            setUserData(error.response.data);;
          });
    },[id])
  return (
    // In this compnent all data come from using url id params
    <Fragment>
        <Box p={5} bgColor='#F5F5F5' w={'50%'}>
            {/* Role Details */}
            <Box>
                <Heading mb={5} fontSize={24} letterSpacing={'0.5px'}>{userData?.user?.UserGroupMember[0]?.userGroupId.split('_').join(' ') || 'n/a'}</Heading>
                <Card w={'90%'}>
                    <CardBody display={'flex'} py={3} px={6}>
                        <Flex flexBasis={'30%'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
                        <Avatar name={(userData?.user?.firstName || 'n/a') + " " + (userData?.user?.lastName || 'n/a')}/>
                        <Text mt={1} fontSize={'16px'} fontWeight={'semibold'} overflowWrap={'break-word'}>{(userData?.user?.firstName || 'n/a') + " " + (userData?.user?.lastName || 'n/a')}</Text>
                        </Flex>
                        <Stack flexBasis={'5%'} direction={'row'} h={'150px'} p={3}>
                            <Divider orientation='vertical' border={'1px solid rgba(0, 0, 0, 0.15)'} /> 
                        </Stack>
                        
                        <Flex flexBasis={'45%'} justifyContent={'space-between'} px={4}> 
                            <Flex flexDirection={'column'} alignItems={'start'} justifyContent={'center'}>
                                <Heading fontSize={'15px'} color={'#A1A1A1'}>Email ID</Heading>
                                <Text fontSize={'15px'}  overflowWrap={'break-word'}>{userData?.user?.email || 'n/a'}</Text>
                            </Flex>
                            <Flex flexDirection={'column'} alignItems={'start'} justifyContent={'center'}>
                                <Heading fontSize={'15px'} color={'#A1A1A1'}>Contact No.</Heading>
                                <Text fontSize={'15px'}>{userData?.user?.phone || 'n/a'}</Text>
                            </Flex>
                        </Flex>
                </CardBody>
                </Card>
            </Box>
            {/* Order Status Table */}
{/*             
            <UserStatusTable head={["Delivery ID", "Delivery Date", "Type of Request", "Status"]} 
                data={[{deliveryDate: "#178987", deliveryStatus: "1/1/2023", typeOfRequest: "Return", status: "In Progress" },{deliveryDate: "#178987", deliveryStatus: "1/1/2023", typeOfRequest: "Replacement", status: "Delivered" },{deliveryDate: "#178987", deliveryStatus: "1/1/2023", typeOfRequest: "Return", status: "In Progress" },{deliveryDate: "#178987", deliveryStatus: "1/1/2023", typeOfRequest: "Replacement", status: "Delivered" }]}/> */}
        </Box>
    </Fragment>
  )
}

export default UserDetails